import React from 'react';

export const HeroDashboard = ({
  overlay,
  salutation,
  country,
  location,
  counter,
  counterDays,
  counterHours,
  counterMinutes,
  bookingId,
  hotelName,
  travelDate,
  airport,
  traveler,
  destinationAirport,
  campsite,
  address,
  phone,
  email,
  children,
}) => {
  let image;

  switch (destinationAirport) {
    case 'AYT':
      image = '/public/assets/images/Antalya.jpg';
      break;
    case 'HER':
      image = '/public/assets/images/Kreta.jpg';
      break;
    case 'HRG':
      image = '/public/assets/images/Hurghada.jpg';
      break;
    default:
      image =
        'https://images.unsplash.com/photo-1505228395891-9a51e7e86bf6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2000&q=80';
  }

  return (
    <div className="w-full flex flex-col justify-end items-start relative overflow-hidden px-8 py-8 lg:min-h-[500px]">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover animate-kenburn scale-1"
          src={image}
          alt={country}
        />
      </div>

      {overlay && (
        <div className="bg-black/40 w-full h-full absolute inset-0 z-10"></div>
      )}

      <div className="relative z-20 w-full flex flex-col">
        {salutation && (
          <div className="text-white text-center lg:text-left font-xs text-shadow mb-2">
            {salutation}
            <br />
          </div>
        )}

        <div className="mb-6 text-white text-center lg:text-left font-semibold text-2xl lg:text-5xl text-shadow">
          {location}
        </div>

        {counter && (
          <div className="bg-brand-1/60 rounded-md w-full lg:max-w-md text-brand-1 h-fit relative mt-10 mb-2 lg:mb-6">
            <div className="absolute top-0 left-0 -rotate-12 -translate-x-2 -translate-y-3 text-white font-medium text-3xl italic">
              <span>Richtung</span>
              <br />
              <span className="ml-12">Glück in</span>
            </div>
            <div className="px-8 mt-20 mb-4">
              <div className="flex w-full space-x-2">
                <div className="w-1/3 bg-[#e1cad4] rounded-sm shadow-md py-1 text-center text-xs">
                  <span className="font-semibold text-lg block">
                    {counterDays}
                  </span>
                  Tagen
                </div>
                <div className="w-1/3 bg-[#e1cad4] rounded-sm shadow-md py-1 text-center text-xs">
                  <span className="font-semibold text-lg block">
                    {counterHours}
                  </span>
                  Stunden
                </div>
                <div className="w-1/3 bg-[#e1cad4] rounded-sm shadow-md py-1 text-center text-xs">
                  <span className="font-semibold text-lg block">
                    {counterMinutes}
                  </span>
                  Minuten
                </div>
              </div>
            </div>
          </div>
        )}

        {bookingId && (
          <div className="mt-2 text-white text-shadow">
            <span className="mr-1 icon icon-hash"></span> {bookingId}
          </div>
        )}

        {hotelName && (
          <div className="mt-2 text-white text-shadow">
            <span className="mr-1 icon icon-hotel"></span> {hotelName}
          </div>
        )}

        {travelDate && (
          <div className="mt-2 text-white text-shadow">
            <span className="mr-1 icon icon-calendar"></span> {travelDate}
          </div>
        )}

        {airport && (
          <div className="mt-2 text-white text-shadow">
            <span className="mr-1 icon icon-flight-up"></span> {airport}
          </div>
        )}

        {traveler && (
          <div className="mt-2 text-white text-shadow">
            <span className="mr-1 icon icon-group"></span> {traveler}
          </div>
        )}

        {campsite && (
          <div className="mt-2 text-white text-shadow">
            <span className="mr-1 icon icon-campingplace"></span> {campsite}
          </div>
        )}

        {address && (
          <div className="mt-2 text-white text-shadow">
            <span className="mr-1 icon icon-region"></span> {address}
          </div>
        )}

        {phone && (
          <div className="mt-2 text-white text-shadow">
            <span className="mr-1 icon icon-telephone"></span> {phone}
          </div>
        )}

        {email && (
          <div className="mt-2 text-white text-shadow">
            <span className="mr-1 icon icon-mail"></span> {email}
          </div>
        )}

        {children}
      </div>
    </div>
  );
};

export default HeroDashboard;
